import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanListPageUI from './LoanListPageUI.js'

class LoanListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loanList: null,
      fundSourceList: null,
    }
  }

  render() {
    return (
      <LoanListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        fundSourceList={this.state.fundSourceList}
        loanList={this.state.loanList}
        onRefreshClick={this.onRefreshClick}
        onTypeChange={this.onTypeChange}
        openOrClosed={this.props.match.path.endsWith('/retail') ? 'retail' : 'disbursed'}
        pageTitle='Disbursed loans'
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    const queryParameters = new URLSearchParams(window.location.search)
    this.getLoans(context, context.filter)
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.path.endsWith('/retail') === prevProps.match.path.endsWith('/retail')) {
      return
    }
    window.location.reload();
  }

  onTypeChange = (type) => {
    this.getLoans(this.props.context, type)
  }

  getLoans(context, stp) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans`,
      cacheKey: CacheKeys.AllLoans('disbursed', stp),
      callback: this.getLoansCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, { openOrClosed: 'disbursed', stp: stp === 'stp' ? true : false })
  }

  getLoansCallback = (response) => {
    let loanList = []
    if (this.props.match.path.endsWith('/retail')) {
      loanList = response.loanList.filter(l => l.loanType === 'retail')
    }
    if (this.props.match.path.endsWith('/nonRetail')) {
      loanList = response.loanList.filter(l => l.loanType !== 'retail')
    }
    this.setState({ errorList: response.errorList, loanList: loanList, fundSourceList: response.fundSourceList })
  }

  onRefreshClick = () => {
    /*
    this.state.loanList.forEach(loan => {
      CacheManager.removeObject(CacheKeys.BillsByLoanId(loan.loanId))
      CacheManager.removeObject(CacheKeys.Orders(loan.loanId, ''))
      if (loan.termSheet)
        CacheManager.removeObject(CacheKeys.Order(loan.termSheet.estimateId))
    })
    */
    CacheManager.removeObject(CacheKeys.AllLoans('disbursed', this.props.context.filter))
    this.setState({ loanList: null, errorList: null })
    this.getLoans(this.props.context, this.props.context.filter)
  }
}

export default withRouter(LoanListPageSF)
